import React from 'react'
import LogIn from '../components/LogIn/LogIn'

function LoginPage() {
    return (
        <div>
            <LogIn />
        </div>
    )
}

export default LoginPage
